import * as React from "react";

import WithLink from "features/common/components/WithLink";

import { COLORS } from "./consts";
import { PrimaryButtonColorProps } from "./PrimaryButton";
import PrimaryButtonWhite from "./PrimaryButtonWhite";

type Props = PrimaryButtonColorProps;

export default function PrimaryButtonWhiteWithPremiumGradient(props: Props) {
  return <PrimaryButtonWhite color={COLORS.GRADIENT} {...props} />;
}

export const PrimaryButtonWhiteWithPremiumGradientWithLink = WithLink(
  PrimaryButtonWhiteWithPremiumGradient
);
